import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, getStoredUser } from "../lib/api";

export default function AuthGate({ children }) {
  const location = useLocation();
  const token = getToken();
  const user = getStoredUser();
  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
